import { render, staticRenderFns } from "./AddSkinCheckupProduct.vue?vue&type=template&id=80f2036a&scoped=true"
import script from "./AddSkinCheckupProduct.vue?vue&type=script&lang=js"
export * from "./AddSkinCheckupProduct.vue?vue&type=script&lang=js"
import style0 from "./AddSkinCheckupProduct.vue?vue&type=style&index=0&id=80f2036a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f2036a",
  null
  
)

export default component.exports